angular.module('eStories.feature-carousel.compnt', [
    'eStories.common.directives',
    'eStories.carousel.service',
    'eStories.catalog.model',
    'eStories.compnt.starRating',
    'eStories.compnt.grid'
])

    .component('featureCarousel', {
        transclude: true,
        bindings: {
            type: '@',
            data: '<'
        },

        controller: 'CarouselCtrl',
        controllerAs: 'carouselCtrl',
        templateUrl: '/components/templates/carousels/feature-carousel/featureCarousel.tmpl.html'

    });
